import React, {memo, useEffect, useState} from "react";
import Loading from "../../components/Loading";
import RegistrationForServiceHeader from "./components/Header";
import RegistrationForServiceFooter from "./components/Footer";
import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";
import Step4 from "./Step4";
import Step5 from "./Step5";
import About from "./About";
import Profile from "./Profile";
import Services from "./Services";
import {useRequest} from "../../hooks/request.hook";
import {useAuth} from "../../hooks/auth.hook";
import "./index.scss";


const RegistrationForService = ({id, ak}) => {
    const [loading, setLoading] = useState(true);
    const [widgetInfo, setWidgetInfo] = useState(null);
    const [page, setPage] = useState(1);
    const [step, setStep] = useState(1);
    const [selectServiceId, setSelectServiceId] = useState(0);
    const [selectedDay, setSelectedDay] = useState(new Date());
    const [selectSessions, setSelectSessions] = useState([]);
    const [errors, setErrors] = useState([]);
    const {request} = useRequest();
    const {login} = useAuth();

    useEffect(() => {
        (async() => {
            setLoading(true);

            if(id) {
                await request({
                    url: `/api/widget/widget_services?id=${id}`,
                    withoutToken: true
                }, data => {
                    if(data) {
                        setWidgetInfo(data);
                    } else {
                        setErrors(['Что-то пошло не так...']);
                    }
                }, e => {
                    if(e.isAxiosError && e.response) {
                        if(e.response.data.errors) {
                            setErrors(Object.keys(e.response.data.errors).map(key => `Ошибка ${key}: ${e.response.data.errors[key]}`));
                        } else {
                            setErrors([`Ошибка ${e.response.status}: ${e.response.statusText}`]);
                        }
                    } else {
                        setErrors(['Что-то пошло не так...']);
                    }
                });
            } else {
                setErrors(['Ошибка: Нет идентификатора виджета']);
            }

            setLoading(false);
        })();
    }, [id, request]);

    useEffect(() => {
        (async() => {
            setLoading(true);

            if(ak) {
                await request({
                    url: '/api/client/authentication/through',
                    method: 'POST',
                    rkfToken: ak
                }, data => {
                    if(data) {
                        login(data.token, data.user);
                    }
                },e => {
                    if(e.isAxiosError && e.response) {
                        if(e.response.data?.errors?.error) {
                            setErrors([e.response.data.errors.error]);
                        } else {
                            setErrors(['Невозможно авторизоваться при помощи Rkf.Online']);
                        }
                    } else {
                        setErrors(['Что-то пошло не так...']);
                    }
                });
            } else {
                setErrors(['Ошибка: Нет авторизационного токена.']);
            }

            setLoading(false);
        })();
    }, [ak, request, login]);

    return (
        <div className="registration-for-service">
            {loading ?
                <Loading/> :
                !errors.length ?
                    <>
                        <RegistrationForServiceHeader
                            company_name={widgetInfo.company_name}
                            picture_link={widgetInfo.picture_link}
                            avatar_link={widgetInfo.avatar_link}
                            isAvatarHidden={widgetInfo.hide_provider_avatar}
                            page={page}
                            step={step}
                            setStep={setStep}
                        />
                        <div className="registration-for-service__content">
                            {page === 1 ?
                                step === 1 ? <Step1
                                                services={widgetInfo.services}
                                                setStep={setStep}
                                                setSelectServiceId={setSelectServiceId}
                                             /> :
                                step === 2 ? <Step2
                                                selectServiceId={selectServiceId}
                                                selectedDay={selectedDay}
                                                setSelectedDay={setSelectedDay}
                                                setStep={setStep}
                                             /> :
                                step === 3 ? <Step3
                                                selectServiceId={selectServiceId}
                                                selectedDay={selectedDay}
                                                selectSessions={selectSessions}
                                                setSelectSessions={setSelectSessions}
                                                setStep={setStep}
                                             /> :
                                step === 4 ? <Step4
                                                selectSessions={selectSessions}
                                                setSelectSessions={setSelectSessions}
                                                setStep={setStep}
                                             /> :
                                <Step5
                                    clearAll={() => setStep(1)}
                                    redirectToServices={() => {
                                        setPage(4);
                                        setStep(1);
                                    }}
                                /> :
                            page === 2 ?
                                <About id={id}/> :
                            page === 3 ?
                                <Profile /> :
                                <Services />
                            }
                        </div>
                        <RegistrationForServiceFooter
                            page={page}
                            setPage={setPage}
                        />
                    </> :
                    <div className="registration-for-service__errors">
                        {errors.map((error, i) =>
                            <p key={`error-${i}`}>{error}</p>
                        )}
                    </div>
            }
        </div>
    )
};

export default memo(RegistrationForService);